/**
 * * v3: Update for check mark properties - selectAll, toExport
 * * Issue No.: https://github.com/wisedoc-inc/wisedoc-web-app/issues/1479
 */
export default (params) => {
  const { fieldType, fieldData } = params;

  const {
    document: { nodes: documentNodes },
  } = fieldData;

  const filteredArrayItems = documentNodes.filter(
    (_, index) => index % 2 === 0,
  );

  const { length: noOfArrayItems } = filteredArrayItems;
  if (noOfArrayItems > 0) {
    let selectAll = 0;

    /**
     * Iterate through each personal link and find the ones which are ready to get exported.
     * Increase the count of 'selectAll' for every exportable personal link
     */
    filteredArrayItems.forEach((arrayItem) => {
      const { data: arrayItemData } = arrayItem;
      const { toExport: isExported } = arrayItemData;
      if (isExported) {
        selectAll += 1;
      }
    });

    /**
     * Update array items object
     */
    const updatedArrayItems = {
      ...fieldData,
      document: {
        ...fieldData.document,
        data: {
          ...fieldData.document.data,
          version: {
            number: 3,
            updated: true,
          },
          selectAll,
        },
      },
    };

    return { [fieldType]: updatedArrayItems };
  }

  return null;
};
